<template>
  <van-list
    :loading="loadingVal"
    :finished="finished"
    :offset="100"
    :loading-text="loadingText"
    :finished-text="finishedText"
    :error.sync="errorits"
    :error-text="errorText"
    @load="onLoad"
  >
    <slot> </slot>
  </van-list>
</template>
<script>
export default {
  props: {
    value: {
      type: Boolean,
    },
    finished: {
      type: Boolean,
    },
    error: {
      type: Boolean,
    },
    finishedText: {
      type: String,
      default: "There's nothing more left",
    },
    errorText: {
      type: String,
      default: "Request failed, click to reload",
    },
    loadingText: {
      type: String,
      default: "loading...",
    },
  },
  
  watch: {
    value() {
      console.log("改变寄售状态");
      this.loadingVal=this.value
    },
    error(){
      this.errorits=this.error
    }
  },
  data() {
    return {
      loadingVal: this.value,
      errorits:this.error
    };
  },
  methods: {
    onLoad() {
      console.log('粗发')
      this.$emit("load");
    },
  },
};
</script>
<style lang="scss" scoped></style>
